<template>
  <div>
    <a-card v-if="listEnable" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row v-if="enterpriseId == ''" :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange1"
                  v-model="queryParam.enterpriseId"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data" :title="item.enterpriseName" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
                <a-select  v-model="queryParam.installType" allowClear="true" @change="handleSelect">
                  <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌" style="margin-left: 42px">
                <!--<a-input v-model="queryParam.brandName"/>-->
                <a-select
                  showSearch

                  optionFilterProp="children"
                  @change="handleChange6"
                  v-decorator="['brandId']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data1" :title="item.brandName" :key="item.brandId">{{item.brandName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="型号" style="margin-left: 28px">
                <!--<a-input  v-model="queryParam.modelName"/>-->
                <a-select
                  showSearch

                  optionFilterProp="children"
                  @change="handleChange9"
                  v-decorator="['modelId']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data2" :title="item.modelName" :key="item.modelId">{{item.modelName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件类型">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange2"
                  v-model="queryParam.accessoryType"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data4" :title="item.accessoryType" :key="item.accessoryType">{{item.accessoryType}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件型号">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange4"
                  v-model="queryParam.accessoryCategory"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data5" :title="item.accessoryCategory" :key="item.accessoryCategory">{{item.accessoryCategory}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件名称" style="margin-left: 14px;">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange7"
                  v-model="queryParam.accessoryName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data3" :title="item.accessoryName" :key="item.accessoryName">{{item.accessoryName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件规格">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange10"
                  v-model="queryParam.accessorySpecification"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data6" :title="item.accessorySpecification" :key="item.accessorySpecification">{{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件状态">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange3"
                  v-model="queryParam.forbidden"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option value="0" title="正常">正常</a-select-option>
                  <a-select-option value="1" title="禁用">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="库存位置">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange5"
                  v-model="queryParam.storeId"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data7" :title="item.storeName" :key="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="费用承担方">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange8"
                  v-model="queryParam.payType"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option value="1" title="锁安">锁安</a-select-option>
                  <a-select-option value="0" title="企业">企业</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-row>
                  <a-col :span="24" style="text-align: right">
                    <a-button type="primary" htmlType="submit" @click="handleInquire">查询</a-button>
                    <a-button style="margin-left: 8px" @click="handleClear">清空</a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="enterpriseId != ''" :gutter="16">
            <!--<a-col :span="6">-->
            <!--<a-form-item label="企业名称">-->
            <!--<a-select-->
            <!--showSearch-->
            <!--optionFilterProp="children"-->
            <!--@change="handleChange1"-->
            <!--v-model="queryParam.enterpriseId"-->
            <!--:filterOption="filterOption"-->
            <!--allowClear="true"-->
            <!--&gt;-->
            <!--<a-select-option v-for="item of data" :title="item.enterpriseName" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>-->
            <!--</a-select>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
                <a-select  v-model="queryParam.installType" allowClear="true" @change="handleSelect">
                  <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌" style="margin-left: 42px">
                <!--<a-input v-model="queryParam.brandName"/>-->
                <a-select
                  showSearch

                  optionFilterProp="children"
                  @change="handleChange6"
                  v-decorator="['brandId']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data1" :title="item.brandName" :key="item.brandId">{{item.brandName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="型号" style="margin-left: 28px">
                <!--<a-input v-model="queryParam.modelName"/>-->
                <a-select
                  showSearch

                  optionFilterProp="children"
                  @change="handleChange9"
                  v-decorator="['modelId']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data2" :title="item.modelName" :key="item.modelId">{{item.modelName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件类型">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange2"
                  v-model="queryParam.accessoryType"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data4" :title="item.accessoryType" :key="item.accessoryType">{{item.accessoryType}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件型号">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange4"
                  v-model="queryParam.accessoryCategory"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data5" :title="item.accessoryCategory" :key="item.accessoryCategory">{{item.accessoryCategory}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件名称" style="margin-left: 14px;">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange7"
                  v-model="queryParam.accessoryName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data3" :title="item.accessoryName" :key="item.accessoryName">{{item.accessoryName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件规格">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange10"
                  v-model="queryParam.accessorySpecification"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data6" :title="item.accessorySpecification" :key="item.accessorySpecification">{{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="配件状态">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange3"
                  v-model="queryParam.forbidden"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option value="0" title="正常">正常</a-select-option>
                  <a-select-option value="1" title="禁用">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="库存位置">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange5"
                  v-model="queryParam.storeId"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data7" :title="item.storeName" :key="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="费用承担方">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange8"
                  v-model="queryParam.payType"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option value="1" title="锁安">锁安</a-select-option>
                  <a-select-option value="0" title="企业">企业</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <a-row>
                  <a-col :span="24" style="text-align: right">
                    <a-button type="primary" htmlType="submit" @click="handleInquire">查询</a-button>
                    <a-button style="margin-left: 8px" @click="handleClear">清空</a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
          </a-row>
          <a-divider> </a-divider>
          <a-row>
            <a-col :span="4" :offset="20" style="text-align: right">
              <a-button v-if="addEnable" type="primary" icon="plus" @click="handleAdd()">新增</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        style="margin-top: 20px"
        rowKey="accessoryId"
        :columns="columns"
        :scroll="{ x: 2000 }"
        :data="loadData"
        bordered
      >
      <span slot="xunhao" slot-scope="text, record">
      <span>{{selectedRowKeys}}</span>
      </span>
        <span slot="installType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>
      </span>
        <template slot="accessoryPrice" slot-scope="text, record">
          <editable-cell :text="text" @change="onCellChange(record, 'accessoryPrice', $event)" />
        </template>

        <template slot="payTypeName" slot-scope="text, record">
          <editable-cell2 :text="text" @change="onCellChange1(record, 'payTypeName', $event)" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-if="detailEnable" @click="handleShow(record)">查看</a>
          <a-divider v-if="detailEnable" type="vertical"/>
        <span v-if="editEnabel">
          <a @click="handleCompile(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)">分配</a>
          <a-divider type="vertical"/>
          <a v-if="record.forbidden==1" @click="showState(record.accessoryId,record.forbidden,record.enterpriseId)">启用</a>
          <a v-else @click="showState(record.accessoryId,record.forbidden,record.enterpriseId)">禁用</a>
        </span>
        <a-divider v-if="removeEnable && editEnabel" type="vertical"/>
        <a v-if="removeEnable" @click="delByIds(record.accessoryId,record.enterpriseId,record.commonFlag)">删除</a>
      </span>
      </s-table>
      <accessory-modal ref="modal" @ok="handleOk"/>
      <accessory-newlyadded ref="modal2" @ok="$refs.table.refresh(true)"/>
    </a-card>
    <no-authority v-if="!listEnable"></no-authority>
  </div>

</template>

<script>
import { STable } from '@/components'
import { editEnterpriseAccessory,getAccessoryList,delAccessory,getForbiddenAccessory,getEnableAccessory,getSlectCombox,getSelectBrand,getModelNumber } from '@/api/enterprise/accessory'
import { selectAccessoryNameCombox,selectAccessoryTypeCombox,selectAccessoryCategoryCombox,selectAccessorySpecificationCombox,selectStoreCombox } from '@/api/enterprise/accessory'
import AccessoryModal from './modules/AccessoryModal.vue'
import AccessoryNewlyadded from './AccessoryNewlyadded.vue'
import NoAuthority from './NoAuthority'
import { checkPermission } from '@/utils/permissions'
import {getDictMap} from "../../utils/dict"
import store from '@/store'
import AFormItem from "ant-design-vue/es/form/FormItem";

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number :value="value" @change="handleChange" @pressEnter="check" />
          <a-button  class="editable-cell-icon-check"   @click="check">确定</a-button>
          <a-button  class="editable-cell-icon-check"   @click="close">取消</a-button>
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || text }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    handleChange(e) {
      this.value = e;
    },
    check() {
      if(this.value != undefined){
        this.editable = false;
        this.$emit('change', this.value);
      }else{
        this.$message.error('配件金额不能为空！')
      }
    },
    close(){
      this.value = this.text
      this.editable = false
    },
    edit() {
      this.editable = true;
    },
  },
};

const EditableCell2 = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-select
            v-model="value"
            style="width: 150px"
            optionFilterProp="children"
            @change="handleChange"
            @pressEnter="check"
          >
            <a-select-option value="1">锁安</a-select-option>
            <a-select-option value="0">企业</a-select-option>
          </a-select>
          <a-input  @pressEnter="check" style="display: none" />
          <a-button  class="editable-cell-icon-check"   @click="check">确定</a-button>
          <a-button  class="editable-cell-icon-check"   @click="close">取消</a-button>
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || text }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    handleChange(val) {
      if(val==1){
        val='锁安'
      }else if(val==0){
        val='企业'
      }
      this.value = val;
    },
    check() {
      this.editable = false;
      this.$emit('change', this.value);
    },
    edit() {
      this.editable = true;
    },
    close(){
      this.value = this.text
      this.editable = false
    },
  },
};

export default {
  name: 'TableList',
  components: {
    AFormItem,
    STable,
    AccessoryModal,
    AccessoryNewlyadded,
    EditableCell,
    EditableCell2,
    NoAuthority
  },
  // inject: ['reload'],
  data () {
    return {
      size: 'default',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width:60,
          dataIndex: 'rowNum',
          align:'center',
        },
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align:'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installName',
          align:'center'
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
          align:'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align:'center'
        },
        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
          align:'center'
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
          align:'center'
        },
        {
          title: '配件金额',
          dataIndex: 'accessoryPrice',
          scopedSlots: { customRender: 'accessoryPrice' },
          align:'center'
        },
        {
          title: '可使用品牌',
          dataIndex: 'brandName',
          align:'center'
        },
        {
          title: '可使用型号',
          dataIndex: 'modelName',
          align:'center'
        },
        {
          title: '配件状态',
          dataIndex: 'forbiddenStatus',
          align:'center'
        },
        {
          title: '是否通用配件',
          dataIndex: 'commonFlag',
          align:'center'
        },
        {
          title: '费用承担方',
          dataIndex: 'payTypeName',
          scopedSlots: { customRender: 'payTypeName' },
          align:'center'
        },
        {
          title: '库存位置',
          dataIndex: 'storeName',
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getAccessoryList(Object.assign(parameter, this.queryParam))
      },
      data:[],
      data1:[],
      data2:[],
      data3:[],
      data4:[],
      data5:[],
      data6:[],
      data7:[],
      enterpriseId:'',
      restaurantTypes: [],
      listEnable: checkPermission('enterprise:accessory:list'),
      addEnable: checkPermission('enterprise:accessory:add'),
      editEnabel: checkPermission('enterprise:accessory:edit'),
      removeEnable: checkPermission('enterprise:accessory:remove'),
      detailEnable: checkPermission('enterprise:accessory:detail'),
    }
  },
  filters: {},
  async created () {
    // console.log(store.getters)
    this.enterpriseId = store.getters.enterpriseId
    this.restaurantTypes = [];
    this.restaurantOperTypeMap = await getDictMap('install_type');
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({code: key, label: value})
    })
    getSlectCombox().then(res=>{
      // console.log(res.data)
      this.data = res.data
    })
    selectAccessoryNameCombox().then(res=>{
      // console.log(res.data)
      this.data3 = res.data
    })
    selectAccessoryTypeCombox().then(res=>{
      // console.log(res.data)
      this.data4 = res.data
    })
    selectAccessoryCategoryCombox().then(res=>{
      // console.log(res.data)
      this.data5 = res.data
    })
    selectAccessorySpecificationCombox().then(res=>{
      // console.log(res.data)
      this.data6 = res.data
    })
    selectStoreCombox().then(res=>{
      // console.log(res.data)
      this.data7 = res.data
    })
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.handleInquire()
    //   }
    // })
  },
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  methods: {
    handleInquire(){
      this.queryParam.brandId=this.form.getFieldValue('brandId')
      this.queryParam.modelId=this.form.getFieldValue('modelId')
      this.$refs.table.refresh(true)
    },
    handleClear() {
      this.queryParam = {}
      this.data1 = []
      this.data2 = []
      this.form.resetFields()
    },
    handleSelect(value){
      console.log(value)
      this.form.setFieldsValue({
        'brandId':undefined,
        'modelId':undefined
      })
      this.data1=[]
      this.data2=[]
      if(value != undefined){
        getSelectBrand({installType:value}).then(res=>{
          // console.log(res.data)
          this.data1 = res.data
        })
      }
    },
    onCellChange(record, dataIndex, value) {
      // console.log(record, dataIndex, value)
      editEnterpriseAccessory({enterpriseId:record.enterpriseId,accessoryId:record.accessoryId,accessoryPrice:value}).then(res=>{
        // console.log(res.code)
        if(res.code == 0){
          this.handleOk()
          this.$message.success('修改成功')
        }else{
          that.$message.error(res.msg)
        }
      })
    },
    onCellChange1(record, dataIndex, value) {
      // console.log(record, dataIndex, value)
      if(value=='锁安'){
        value=1
      }else if(value=='企业'){
        value=0
      }
      editEnterpriseAccessory({enterpriseId:record.enterpriseId,accessoryId:record.accessoryId,payType:value}).then(res=>{
        // console.log(res.code)
        if(res.code == 0){
          this.$message.success('修改成功')
          this.$nextTick(() => {
            this.handleOk()
          })
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    handleChange1 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange2 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange3 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange4 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange5 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange6 (value) {
      // console.log(`selected ${value}`)
      this.form.setFieldsValue({
        'modelId':undefined
      })
      this.data2 = []
      if(value != undefined){
        getModelNumber({brandId:value}).then(res=>{
          // console.log(res.data)
          this.data2 = res.data
        })
      }
    },
    handleChange7 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange8 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange9 (value) {
      // console.log(`selected ${value}`)
    },
    handleChange10 (value) {
      // console.log(`selected ${value}`)
    },
    handleCompile(record){
      this.$refs.modal.delay(record)
    },
    handleShow (record) {
      this.$refs.modal.delay(record,1)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleAdd () {
      this.$refs.modal2.add()
    },
    handleEdit (record) {
      this.$refs.modal.edit(record)
    },
    handleOk () {
      this.$refs.table.refresh()
    },
    showState (accessoryId, forbidden,enterpriseId) {
      console.log(accessoryId,forbidden,enterpriseId)
      if (forbidden == 0) {
        getForbiddenAccessory({ 'accessoryId': accessoryId,'enterpriseId':enterpriseId }).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbidden == 1) {
        getEnableAccessory({ 'accessoryId': accessoryId,'enterpriseId':enterpriseId }).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    delByIds (accessoryId,enterpriseId,commonFlag) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delAccessory({ accessoryId: accessoryId,enterpriseId:enterpriseId, commonFlag:commonFlag}).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
  },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>
<style scoped>
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px !important;}
</style>
